export default __webpack_public_path__ + "static/hiintcase1-42300ca07443e25a428c807b234f3f63.png";